const Euro = ({ width = '32px', height = '32px' }) => {
  return (
    <svg
      focusable="false"
      viewBox="0 0 48 48"
      width={width}
      height={height}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.5 16.13c-.78-.2-1.6-.17-2.38.12-.8.29-1.6.85-2.3 1.71A7.77 7.77 0 0019.65 20h4.85a1.5 1.5 0 010 3h-10a1.5 1.5 0 010-3h1.99c.42-1.48 1.1-2.82 2-3.93a8.36 8.36 0 013.6-2.64c1.36-.5 2.8-.56 4.18-.2a8 8 0 013.76 2.3 1.5 1.5 0 11-2.18 2.05 5 5 0 00-2.34-1.45zM26 26.5c0-.83-.67-1.5-1.5-1.5h-10a1.5 1.5 0 000 3h2.04c.1.75.44 1.55.81 2.24.49.9 1.17 1.86 2 2.62a7.8 7.8 0 003.7 1.99c1.35.28 2.73.17 4.04-.35a8.43 8.43 0 003.45-2.6 1.5 1.5 0 00-2.34-1.88 5.44 5.44 0 01-2.21 1.7c-.77.3-1.55.36-2.31.2a4.8 4.8 0 01-2.28-1.25v-.01h-.01A7.17 7.17 0 0119.62 28h4.88c.83 0 1.5-.67 1.5-1.5z"
        fill="currentColor"
      ></path>
    </svg>
  );
};

export default Euro;
